(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('signoffcounter', {
      restrict: 'E',
      bindings: {
        patientid: '<?'
      },
      template: `
        <span class="badge badge-error" ng-bind="vm.counter" uib-tooltip="Dokumente zu vidieren" tooltip-placement="auto"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, File, Rlog, vertxEventBusService, $http) {
          let vm = this;

          vm.$onInit = function () {
            if (angular.isUndefined(vm.patientid)) {
              getCounter();
            }
          }; // $onInit()


          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue)) {
              getCounter(changes.patientid.currentValue);
            }
          }; // $onInit()

          function getCounter(patid) {
            let lpatid = patid || undefined;
            let query = [{
              $match: {
                scanstatus: 'assigned',
                active: true
              }
            }, {
              $group: {
                _id: null,
                counter: {$sum: 1}
              }
            }];

            if (angular.isDefined(lpatid)) {
              query[0].$match.patientid = lpatid;
            }

            $http.post('/routes/files/aggregate', query).then(res => {
              vm.counter = 0;
              if (res.data.counter) {
                vm.counter = res.data.counter;
              }
            }, err => {
              Rlog.error('dms.scan', 'signoffcounter', 'signoffcounter.$aggregate failed', {});
              $log.error('signoffcounter.$aggregate failed', err);
            });
          }


          // listen for patdocs updates
          vertxEventBusService.on('scanfile.update', function (message) {
            $log.debug('signoffcounter eb msg caught: ', message);
            getCounter();
          });

          vertxEventBusService.on('files.update', function (message) {
            $log.debug('signoffcounter eb msg file.update caught: ', message);
            getCounter();
          });

          vertxEventBusService.on('files.create', function (message) {
            $log.debug('signoffcounter eb msg file.create caught: ', message);
            getCounter();
          });
        }
      ] // controller
    }); // component

// klammerfriedhof
}());
